import {NgModule} from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {ConclusionViewComponent} from './conclusion-view/conclusion-view.component';
import {ConclusionFormComponent} from './conclusion-form/conclusion-form.component';
import {ConclusionEquipmentResolver} from './services/conclusion-equipment.resolver';
import {ConclusionSignersSpecialistsListResolver} from './services/conclusion-signers-specialists-list.resolver';
import {ConclusionSignersStructureResolver} from './services/conclusion-signers-structure.resolver';
import {LaboratoryDocumentsResolverService} from '@providers/_resolvers/laboratory-documents-resolver.service';
import {ConclusionTechnicalCardResolver} from './services/conclusion-technical-card.resolver';
import {ConclusionResolver} from './services/conclusion.resolver';
import {ConclusionBlankResolver} from './services/conclusion-blank.resolver';
import {CheckPermissionsGuardService} from '@services/guards/check-permissions.guard.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {
    ConclusionFormInspectionParamsFormModalComponent
} from './components/conclusion-form-inspection-params-form-modal/conclusion-form-inspection-params-form-modal.component';
import {ConclusionListComponent} from './conclusion-list/conclusion-list.component';
import {FilteredConclusionResolver} from './services/conclusion-pages/filtered-conclusion.resolver';
import {RoutesStorage} from '@helpers/routes.helper';
import {ConclusionDeviceElementResolver} from './services/conclusion-device-element.resolver';
import {ConclusionStatusSelectValuesListResolver} from './services/filter-params/conclusion-status-select-values-list.resolver';
import {TechnicalDeviceSelectValuesListResolver} from './services/filter-params/technical-device-select-values-list.resolver';
import {WorkingObjectsSelectValuesListResolver} from './services/filter-params/working-objects-select-values-list.resolver';
import {IndustryMethodsSelectValuesListResolver} from './services/filter-params/industry-methods-select-values-list.resolver';

export const conclusionListRoutes: Route[] = [
    {
        path: '',
        component: ConclusionListComponent,
        data: {
            title: 'Заключения',
        },
        resolve: {
            data: FilteredConclusionResolver,
            conclusionStatusSelectValues: ConclusionStatusSelectValuesListResolver,
            technicalDeviceSelectValues: TechnicalDeviceSelectValuesListResolver,
            workingObjectSelectValues: WorkingObjectsSelectValuesListResolver,
            industryMethodsSelectValues: IndustryMethodsSelectValuesListResolver,
        },
    },
];

export const conclusionRoutes: Route[] = [
    {
        path: ':id',
        resolve: {
            conclusionView: ConclusionResolver,
        },
        canActivate: [
            CheckPermissionsGuardService
        ],
        data: {
            permissions: [
                UserNamespace.Permission.technicalDeviceConclusionView,
            ],
            fallbackUrl: RoutesStorage.WorkingObject.list,
        },
        children: [
            {
                path: 'view',
                component: ConclusionViewComponent,
                data: {
                    title: 'Заключение'
                },
            },
        ]
    },
    {
        /**
         * @TODO подумать над роутингом и передачей параметров,
         * ибо нам нужен и элемент и техкарта как при создании, так и при редактировании заключения
         */
        path: ':elementId/:technicalCardId',
        children: [
            {
                path: '',
                redirectTo: 'new',
                pathMatch: 'full'
            },
            {
                path: '',
                children: [
                    {
                        path: 'new',
                        component: ConclusionFormComponent,
                        resolve: {
                            conclusion: ConclusionBlankResolver,
                        },
                        canActivate: [
                            CheckPermissionsGuardService
                        ],
                        data: {
                            title: 'Оформление заключения',
                            permissions: [
                                UserNamespace.Permission.technicalDeviceConclusionCreate,
                            ],
                            fallbackUrl: RoutesStorage.WorkingObject.list,
                        }
                    },
                ]
            },
            {
                path: ':id',
                resolve: {
                    conclusionView: ConclusionResolver,
                },
                canActivate: [
                    CheckPermissionsGuardService
                ],
                data: {
                    permissions: [
                        UserNamespace.Permission.technicalDeviceConclusionUpdate,
                    ],
                    fallbackUrl: RoutesStorage.WorkingObject.list,
                },
                children: [
                    {
                        path: 'edit',
                        component: ConclusionFormComponent,
                        resolve: {
                            equipment: ConclusionEquipmentResolver,
                            conclusion: ConclusionResolver,
                            signersSpecialistsList: ConclusionSignersSpecialistsListResolver,
                            signersStructure: ConclusionSignersStructureResolver,
                            laboratoryDocuments: LaboratoryDocumentsResolverService,
                            technicalCard: ConclusionTechnicalCardResolver,
                            deviceElement: ConclusionDeviceElementResolver,
                        },

                        data: {
                            resolveAsForm: true,
                            title: 'Редактирование заключения',
                            scrollTop: false,
                        },
                        children: [
                            {
                                path: 'params-batch-form',
                                component: ConclusionFormInspectionParamsFormModalComponent,
                                outlet: 'modal',
                                data: {
                                    title: 'Редактирование заключения',
                                    scrollTop: false,
                                }
                            }
                        ]
                    },
                ]
            },
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(conclusionRoutes)
    ],
    exports: [
        RouterModule,
    ],
    declarations: [],
    providers: [],
})
export class ConclusionRoutingModule {
}
